

export const getSocialAuthAppleIdToken = (data) => data.authorization.id_token;